import React from 'react';
import IInvestExpertiseFiltersResult from '../../interfaces/expertise/IInvestExpertiseFiltersResult';
import VInvestExpertiseSynthesisVentureCapital from './VInvestExpertiseSynthesisVentureCapital';

type VInvestExpertiseSynthesisPrivateEquityProps = {
	resultData: IInvestExpertiseFiltersResult;
};

const VInvestExpertiseSynthesisPrivateEquity = (props: VInvestExpertiseSynthesisPrivateEquityProps) => {
	const { resultData } = props;

	return <VInvestExpertiseSynthesisVentureCapital resultData={resultData} />;
};

export default VInvestExpertiseSynthesisPrivateEquity;
